<template>
  <div>
    <headerComponent ref="header"></headerComponent>
    <main>
      <div class="pageHome_1">
        <!-- <div class="slogan">
          <img src="@/assets/image/shouye/text@2x.png" />
        </div> -->
        <div class="carousel">
          <el-carousel :interval="5000" arrow="hover">
            <el-carousel-item v-for="(item, index) in imgList" :key="index">
              <img class="img" :src="item.img" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="bc_bottom">
          <div class="width">
            <div
              class="both"
              v-for="(item, index) in itemExpList"
              :key="index"
              :style="index == 4 ? 'width: 3px' : ''"
            >
              <div v-if="item.img">
                <img :src="item.img" />
              </div>
              <div class="experience">
                <span v-if="index != 4">{{ item.num }}+</span>
                <span>{{ item.txt }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pageHome_2">
        <div class="text">
          <p>核心业务与产品</p>
          <p>
            云译科技专注服务企业和高校，提供智能翻译、教学实训、语言资产等系列产品
          </p>
        </div>
        <div class="imagination">
          <div
            v-for="(item, index) in yewuList"
            :key="index"
            @click="freeTrial(item)"
          >
            <img :src="item.img" />
            <div v-if="index == 0 || index == 1" class="button">立即使用</div>
            <div v-else class="button">申请试用</div>
          </div>
        </div>
        <div class="text" style="margin-top: 92px">
          <p>客户案例</p>
          <p>利用人工智能核心技术助力企业国际化落地获众多行业客户青睐</p>
        </div>
      </div>
      <div class="pageHome_3">
        <div class="cooperation">
          <div v-for="(item, index) in pinpaiList" :key="index">
            <img v-if="item.img" :src="item.img" />
            <div v-else style="width: 345px"></div>
          </div>
        </div>
      </div>
      <div class="pageHome_4">
        <div class="text">
          <p>最新动态</p>
          <p>
            云译致力于打造自然语言处理与机器翻译技术的研究发展平台，做一个有价值的语言技术公司
          </p>
        </div>
        <div class="imgText">
          <div
            v-for="(item, index) in dongtaiList"
            :key="index"
            class="three"
            @click="handleDetail(item)"
          >
            <img :src="item.cover" />
            <div class="both">
              <span>{{
                item.publishTime ? parseTime(item.publishTime) : ""
              }}</span>
              <span>{{ item.title ? item.title : "" }}</span>
            </div>
          </div>
        </div>
        <div class="buttonCenter">
          <div class="button" @click="more">更多新闻</div>
        </div>
      </div>
    </main>
    <footerComponent :footerActive="0"></footerComponent>
  </div>
</template>
<script>
import headerComponent from "@/components/header";
import footerComponent from "@/components/footer";
import { getCDynamics } from "@/api/about/index.js";
import { parseTime } from "@/untils/index";
export default {
  name: "shouYe",
  components: { headerComponent, footerComponent },
  data() {
    return {
      parseTime,
      itemExpList: [
        {
          img: require("@/assets/image/shouye/ic01.png"),
          num: 100,
          txt: "成功项目经验",
        },
        {
          img: require("@/assets/image/shouye/ic02.png"),
          num: 50,
          txt: "行业奖项",
        },
        {
          img: require("@/assets/image/shouye/ic03.png"),
          num: 20,
          txt: "合作院校",
        },
        {
          img: require("@/assets/image/shouye/ic04.png"),
          num: 150,
          txt: "机器同传实战",
        },
        {
          img: "",
          num: "",
          txt: "",
        },
      ],
      yewuList: [
        {
          img: require("@/assets/image/shouye/icon01@2x.png"),
          type: 0,
        },
        {
          img: require("@/assets/image/shouye/icon02@2x.png"),
          type: 1,
        },
        {
          img: require("@/assets/image/shouye/icon03@2x.png"),
          type: 2,
        },
        {
          img: require("@/assets/image/shouye/icon04@2x.png"),
          type: 3,
        },
        {
          img: require("@/assets/image/shouye/icon05@2x.png"),
          type: 4,
        },
        {
          img: require("@/assets/image/shouye/icon06@2x.png"),
          type: 5,
        },
      ],
      pinpaiList: [
        {
          img: require("@/assets/image/shouye/logo01@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo02@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo03@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo04@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo05@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo06@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo07@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo08@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo09@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo10@2x.png"),
        },
        {
          img: require("@/assets/image/shouye/logo11@2x.png"),
        },
        {
          img: "",
        },
      ],
      dongtaiList: [],
      gundongHeight: 0,
      headerChange: false,
      queryForm: {
        pageNum: 1,
        pageSize: 3,
        articleCid: "公司动态",
      },
      timer: null,
      timer1: null,
      timer2: null,
      timer3: null,
      imgList: [
        {
          img: require("@/assets/image/shouye/shouye_banner1.png"),
        },
        {
          img: require("@/assets/image/shouye/shouye_banner2.png"),
        },
        {
          img: require("@/assets/image/shouye/shouye_banner3.png"),
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll, true);
    this.getConsult();
    this.dizeng();
  },
  methods: {
    more() {
      this.$router.push({
        path: "/about",
        query: {
          type: 1,
        },
      });
    },
    getConsult() {
      getCDynamics(this.queryForm).then((res) => {
        if (res.code == 200) {
          this.dongtaiList = res.data || [];
          console.log(this.dongtaiList, "this.dongtaiList");
        } else {
          console.log("aaa");
          this.$message.error(res.msg);
        }
      });
    },
    // 进入动态详情
    handleDetail(item) {
      console.log(item);
      window.scrollTo(0, 0);
      this.$router.push("/about");
      localStorage.setItem("about", 3);
      item.type = true;
      localStorage.setItem("dynamic", JSON.stringify(item));
    },
    freeTrial(ite) {
      if (ite.type == 0) {
        window.open("https://online.cloudtranslation.com/");
      } else if (ite.type == 1) {
        window.open("http://www.transwai.com/");
      } else {
        this.$router.push({
          path: "/about",
          query: {
            type: 2,
          },
        });
      }
    },
    handleScroll() {
      // console.log('滚动高度', window.pageYOffset)
      this.gundongHeight = window.pageYOffset;
      if (this.gundongHeight > 600 && !this.headerChange) {
        this.headerChange = true;

        this.$refs.header.changeHeaderBc();
      } else if (this.gundongHeight < 600 && this.headerChange) {
        this.headerChange = false;
        this.$refs.header.changeHeaderBc();
      }
    },
    dizeng() {
      this.itemExpList[0].num = 0;
      this.itemExpList[1].num = 0;
      this.itemExpList[2].num = 0;
      this.itemExpList[3].num = 0;
      this.timer = setInterval(() => {
        this.itemExpList[0].num = this.itemExpList[0].num + 1;
        if (this.itemExpList[0].num > 100) {
          this.itemExpList[0].num = 100;
          this.timer = null;
        }
      }, 10);
      this.timer1 = setInterval(() => {
        this.itemExpList[1].num = this.itemExpList[1].num + 1;
        if (this.itemExpList[1].num > 50) {
          this.itemExpList[1].num = 50;
          this.timer1 = null;
        }
      }, 10);
      this.timer2 = setInterval(() => {
        this.itemExpList[2].num = this.itemExpList[2].num + 1;
        if (this.itemExpList[2].num > 20) {
          this.itemExpList[2].num = 20;
          this.timer2 = null;
        }
      }, 10);
      this.timer3 = setInterval(() => {
        this.itemExpList[3].num = this.itemExpList[3].num + 1;
        if (this.itemExpList[3].num > 150) {
          this.itemExpList[3].num = 150;
          this.timer3 = null;
        }
      }, 10);
    },
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener("scroll", this.handleScroll, true);

    localStorage.removeItem("about");
    // localStorage.removeItem("solution");
    // localStorage.removeItem("dynamic");
    // localStorage.removeItem("product");
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-carousel {
  width: 100%;
  height: 100%;
  .el-carousel__container {
    height: 100%;
  }
}
.pageHome_1 {
  margin-top: 64px;
  height: 635px;
  position: relative;
  @media screen and (max-width: 1915px) {
    height: 600px;
  }
  @media screen and (max-width: 1750px) {
    height: 575px;
  }
  @media screen and (max-width: 1540px) {
    height: 505px;
  }
  @media screen and (max-width: 1280px) {
    height: 420px;
  }
  .carousel {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
    }
  }
  // .slogan {
  //   position: relative;
  //   padding-top: 243px;
  //   img {
  //     width: 446px;
  //     position: absolute;
  //     right: 150px;
  //   }
  // }
  .bc_bottom {
    height: 100px;
    background: rgba(0, 0, 0, 0.14);
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 10;
    // padding-left: 359px;
    .width {
      width: 1200px;
      margin: 0 auto;
      display: flex;
    }
    .both {
      display: flex;
      width: 300px;
      height: 100px;
      background: rgba(255, 255, 255, 0);
      box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.16);
      justify-content: center;
      align-items: center;
    }
    img {
      width: 44px;
    }
    .experience {
      display: flex;
      flex-direction: column;
      margin-left: 15px;
      span:nth-of-type(1) {
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
      span:nth-of-type(2) {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
.pageHome_2 {
  padding: 115px 0px 64px 0px;

  .imagination {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 1404px;
    margin: 0 auto;
    margin-top: 81px;
    position: relative;
    div {
      margin-bottom: 30px;
    }
    img {
      width: 450px;
      @media screen and (max-width: 1280px) {
        width: 400px;
      }
    }
    .button {
      width: 110px;
      height: 42px;
      border: 2px solid #dae1ee;
      border-radius: 2px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #818a9b;
      position: absolute;
      margin-top: -100px;
      margin-left: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}
.pageHome_3 {
  // height: 660px;
  background-image: url("~@/assets/image/shouye/bg2.png");
  background-size: cover;
  padding: 75px 0px 114px 0px;
  box-sizing: border-box;
  .cooperation {
    display: flex;
    flex-wrap: wrap;
    min-width: 1000px;
    max-width: 1420px;
    margin: 0 auto;
    justify-content: center;
    img {
      width: 345px;
    }
  }
}
.pageHome_4 {
  padding: 140px 0px 170px 0px;
  .imgText {
    display: flex;
    min-width: 1000px;
    max-width: 1410px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 80px;
    @media screen and (max-width: 1280px) {
      transform: scale(0.7);
    }
    img {
      width: 450px;
      @media screen and (max-width: 1280px) {
        width: 400px;
      }
    }
  }

  .three {
    background: #ffffff;
    box-shadow: 0px 10px 20px 0px rgba(62, 67, 132, 0.12);
    border-radius: 2px;
    cursor: pointer;
    height: 480px;
    img {
      height: 256px;
    }
    .both {
      display: flex;
      flex-direction: column;
      width: 450px;
      height: 218px;
      padding: 30px 53px 0px 24px;
      box-sizing: border-box;
      @media screen and (max-width: 1280px) {
        width: 400px;
      }
      span:nth-of-type(1) {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      span:nth-of-type(2) {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1f1f1f;
        margin-top: 24px;
      }
    }
  }
  .buttonCenter {
    display: flex;
    justify-content: center;
    margin-top: 74px;
  }
  .button {
    width: 170px;
    height: 50px;
    background: #f9f9f9;
    border: 2px solid #3466ef;
    border-radius: 25px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3466ef;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
.text {
  text-align: center;
  p:nth-of-type(1) {
    font-size: 38px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2c3e50;
  }
  p:nth-of-type(2) {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #66768a;
    margin-top: 39px;
  }
}

/deep/.el-carousel__button {
  width: 16px;
  height: 4px;
  border-radius: 9px;
}
/deep/.el-carousel__indicators--horizontal {
  bottom: 124px;
  left: 50%;
}
</style>
